<template><div><h1>VUX V2.5.0 发布日志</h1>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 支持 prop:close-on-confirm</li>
<li>[feature] 支持 prop:show-input</li>
</ul>
<h2><a href="/zh-CN/components/datetime-view.html">DatetimeView</a></h2>
<ul><li>[feature] 新组件 DatetimeView</li>
</ul>
<h2><a href="/zh-CN/components/loading.html">Loading</a></h2>
<ul><li>[feature] 支持 prop:transition</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[feature] 添加禁用背景颜色. #1630</li>
</ul>
<h2><a href="/zh-CN/components/x-switch.html">XSwitch</a></h2>
<ul><li>[feature] 支持使用 prop:prevent-default 来阻止自动设定值 #1606</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.0-244.vue?258e41cc